import { Box, Flex } from '@chakra-ui/react';

import { GreenFilledCheck } from 'assets/assetsV1/iconComponents';

import { TextBodyMedium, TextLabel } from 'uiToolkitV1/Typography';

const Node = ({ isActive, isCompleted }: { isActive: boolean; isCompleted: boolean }) => {
  if (isActive)
    return (
      <Box
        w="12px"
        h="12px"
        borderRadius="50%"
        bg="timeline.AF5C20"
        className="timeline-icon timeline-circular-icon timeline-in-progress-icon"
        zIndex={0}
      />
    );

  if (isCompleted)
    return (
      <GreenFilledCheck
        boxSize="16px"
        p="2px"
        className="timeline-icon timeline-complete-icon"
        borderRadius="50%"
        zIndex={0}
      />
    );

  return (
    <Box
      className="timeline-icon timeline-circular-icon"
      w="12px"
      h="12px"
      borderRadius="50%"
      bg="icon.g3"
      zIndex={0}
    />
  );
};

const Connector = ({ isCompleted, isActive }: { isCompleted: boolean; isActive: boolean }) => {
  let color = 'timeline.CFD7DF';
  if (isCompleted) {
    color = 'timeline.DBF2D3';
  } else if (isActive) {
    color = 'timeline.FFEFD5';
  }

  return (
    <Box flex="1" h="12px" mx="-8px">
      <Box h="full" bg={color} />
    </Box>
  );
};

export type BUDGET_TIMELINE_TYPE = 'BASELINE_SET' | 'APPROVER_ADJUSTED' | null;

export function BudgetTimeline({ status = null }: { status: BUDGET_TIMELINE_TYPE }) {
  const steps = [
    {
      id: 1,
      label: 'Set baseline budgets',
      isCompleted: ['BASELINE_SET', 'APPROVER_ADJUSTED'].includes(status),
      isActive: status === null,
    },
    {
      id: 2,
      label: 'Adjust approver budgets',
      isCompleted: status === 'APPROVER_ADJUSTED',
      isActive: status === 'BASELINE_SET',
    },
  ];

  return (
    <Flex align="center" justify="space-between">
      {steps.map((step, index) => (
        <Flex flex={1} key={step.id} flexDir="column" gap="7.5px">
          <Flex align="center">
            <Node isActive={step.isActive} isCompleted={step.isCompleted} />
            {index < steps.length - 1 && (
              <Connector isCompleted={steps[index + 1].isCompleted} isActive={steps[index + 1].isActive} />
            )}
          </Flex>
          <Flex flexDir="column" flexShrink={0}>
            <TextLabel color={step.isActive ? '#004F67' : 'text.g2'}>Step {step.id}</TextLabel>
            <TextBodyMedium color={step.isActive ? '#004F67' : 'text.g2'} bold>
              {step.label}
            </TextBodyMedium>
          </Flex>
        </Flex>
      ))}
    </Flex>
  );
}
